import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { SearchtoolboxService } from './../../_services/searchtoolbox.service';

@Component({
    selector: 'app-job-description-modal',
    templateUrl: './job-description-modal.component.html',
    styleUrls: ['./job-description-modal.component.scss'],
    standalone: false
})
export class JobDescriptionModalComponent implements OnInit {
  @Output() parsedJDData: EventEmitter<any> = new EventEmitter();

  incorrectFileFormat: boolean = false;
  specialCharaterError: boolean = false;
  uploadedFilename: string;
  isUploadedFileCorrect: boolean = false;
  showJDNotAddedError: boolean = false;
  enteredJobDescription: string;
  uploadedFile: any = undefined;
  disableManualJDInput: boolean = false;
  fileSizeLimitExceeded: boolean = false;

  constructor(
    private modalService: NgbModal,
    private searchToolboxService: SearchtoolboxService,
    private _localstorageservice : LocalStorageService
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  uploadFile(event) {
    this.resetFormFields();
    this.uploadedFile = event.target.files[0];
    
    let validFileExtensions = ['doc', 'docx', 'pdf', 'txt'];
    let uploadedFileExtension = this.uploadedFile.name.split('.')[1];
    let filenameRegex = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/;
    
    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }
    if (filenameRegex.test(this.uploadedFile.name.split(".")[0])) {
      this.specialCharaterError = true;
    } 
    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
    }

    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded) {
      this.isUploadedFileCorrect = true;
      this.uploadedFilename = this.uploadedFile.name;
      this.disableManualJDInput = true;
    }
    
  }

  addJobDescription() {
    if ( (this.enteredJobDescription && this.enteredJobDescription.toString().trim().length) 
      || (this.uploadedFile && this.isUploadedFileCorrect) ) {
      let data = {
        usernumber: this._localstorageservice.getItem('usernumber')
      }

      // Process uploaded JD file
      if (!this.enteredJobDescription || this.enteredJobDescription.toString().trim().length == 0) {
        GlobalService.toBase64(this.uploadedFile).then(encodedFileData => {
          data['isbase64encoded'] = 'yes';
          data['jobdescription'] = encodedFileData;
          data['filename'] = 'jobDescription.' + this.uploadedFile.name.split('.')[1];
          this.parseJobDescription(data);
        }).catch(err => {
          // console.log("---Some error in converting file data to base64---", err);
          this.parsedJDData.emit({});
        });
      } 
      // Process the manually added JD
      else {
        data['isbase64encoded'] = 'no';
        data['jobdescription'] = this.enteredJobDescription.toString().trim();
        data['filename'] = 'jobDescription.txt';
        this.parseJobDescription(data);
      }
    } else {
      this.showJDNotAddedError = true;
    }
  }

  resetFormFields() {
    this.enteredJobDescription = '';
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.isUploadedFileCorrect = false;
    this.uploadedFilename = undefined;
    this.disableManualJDInput = false;
    this.showJDNotAddedError = false;
    this.fileSizeLimitExceeded = false;
  }

  parseJobDescription(data: any) {
    this.searchToolboxService.parseJobDescription(data).subscribe((res: any) => {
      this.closeModal();
      this.parsedJDData.emit(res);
    });
  }

  clearEnteredJD() {
    this.enteredJobDescription = '';
  }

}
